export default __webpack_public_path__ + "static/-green-1f597eeea72ee339fa9a92c8bdb456e8.jpg";